import { render, staticRenderFns } from "./PFormSelectTranslateItems.vue?vue&type=template&id=44e73522&scoped=true"
import script from "./PFormSelectTranslateItems.vue?vue&type=script&lang=ts"
export * from "./PFormSelectTranslateItems.vue?vue&type=script&lang=ts"
import style0 from "./PFormSelectTranslateItems.vue?vue&type=style&index=0&id=44e73522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e73522",
  null
  
)

export default component.exports